import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import * as Sentry from '@sentry/react'

export const useSyncSentryUser = () => {
  const { requestID } = useParams<{ requestID: string }>()

  useEffect(() => {
    if (requestID) {
      Sentry.setUser({ id: requestID })
      return
    }
    Sentry.setUser(null)
  }, [requestID])
}
